<ng-container *ngIf="salesperson$ | async as salesperson">
  <ng-container *ngIf="dialogConfig$ | async as dialogConfig">
    <div class="assigned-person" (click)="openDialog(dialogConfig)" data-action="assigned-salesperson">
      <span *ngIf="salesperson?.photoUrlHttps; else defaultImage" class="image-wrapper">
        <img src="{{ salesperson?.photoUrlHttps }}" />
      </span>
      <ng-template #defaultImage>
        <span class="image-wrapper">
          <img src="{{ defaultImageUrl }}" />
        </span>
      </ng-template>
      <span class="person-details">
        <div class="person-name">
          {{ 'CONTACT_SALESPERSON.CONTACT' | translate }}
          {{ salesperson?.firstName || '' }} {{ salesperson?.lastName || '' }}
        </div>
        <div class="person-title-wrapper">
          <span class="person-title">{{ salesperson?.jobTitle }}</span>
        </div>
      </span>
    </div>
  </ng-container>
</ng-container>
